import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessagereact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.5378 15.078C20.2931 13.9422 20.7367 12.5749 20.7367 11.1025C20.7367 7.18317 17.5974 4 13.7166 4H10.027C6.14621 4 3 7.18317 3 11.1096C3 15.0359 6.14621 18.2191 10.027 18.2191H14.1462C15.6223 18.2191 17.0915 18.4926 18.4706 19.0254L21 20L19.5378 15.078Z" })
});
export default SvgMessagereact;
